import { useSnackbar } from "notistack";
import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import { TITLE_PAGE } from "../../core/constants/appGlobals";
import useAuth from "../../core/hooks/useAuth";
import useConstructor from "../../core/hooks/useConstructor";
import { PermissionsType } from "../../core/models/Permission";
import { isArrayValid } from "../../helpers/utility";

/* eslint-disable @typescript-eslint/no-explicit-any*/
type ProtectedRouteProps = {
  permissionType: PermissionsType | PermissionsType[];
  component?: any;
  children?: React.ReactNode;
  title?: string;
} & any;
/* eslint-enable @typescript-eslint/no-explicit-any*/

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { component: Component, children, permissionType, title, ...rest } = props;
  const authProvider = useAuth();
  const isAuthenticated = authProvider.get();
  let hasPermission = false;
  let blockedByScreenSize = false;
  const toastr = useSnackbar();

  React.useEffect(() => {
    if (title) {
      const fullTitle = `${TITLE_PAGE}${title ? " - " + title : ''}`;

      document.title = fullTitle;
    }
  }, [title]);

  if (isArrayValid(permissionType)) {
    hasPermission = authProvider.hasAnyPermission(permissionType);
    blockedByScreenSize = authProvider.mobileRestriction(permissionType);
  } else {
    hasPermission = authProvider.hasPermission(permissionType);
    blockedByScreenSize = authProvider.mobileRestriction([permissionType]);
  }

  if (authProvider.isFreeUser && rest.path !== "/home/") {
    hasPermission = false;
  }

  if (isAuthenticated && !hasPermission) {
    toastr.enqueueSnackbar("Ops! Seu usuário não possuí acesso para esta feature!", {
      variant: "warning",
    });
  }

  if (isAuthenticated && hasPermission && blockedByScreenSize) {
    toastr.enqueueSnackbar("Ops! Esta feature só está disponível na versão web da aplicação!", {
      variant: "info",
    });
  }

  if (!Component && children) {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          isAuthenticated === true && hasPermission === true && blockedByScreenSize === false ? (
            children
          ) : isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/home/",
                state: { from: location },
              }}
            />
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location },
              }}
            />
          )
        }
      />
    );
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated === true && hasPermission === true && blockedByScreenSize === false ? (
          <Component {...rest} />
        ) : isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/home/",
              state: { from: location },
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
export default ProtectedRoute;
